// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import applyPropBuilder from "@insite/mobius/utilities/applyPropBuilder";
import React from "react";
import { ThemeProps, withTheme } from "styled-components";

export interface DrawerLinkPresentationProps {
    headlineTypographyProps?: TypographyPresentationProps;
}

interface OwnProps extends LinkProps {
    onClick?: LinkProps["onClick"] | undefined;
    href?: LinkProps["href"] | undefined;
    title: string;
}

type DrawerLinkProps = DrawerLinkPresentationProps & OwnProps & ThemeProps<BaseTheme>;

const DrawerLink: React.FC<DrawerLinkProps> = ({ onClick, title, href, ...otherProps }) => {
    const { spreadProps } = applyPropBuilder(otherProps, { component: "drawer" });
    return (
        <Link
            href={href}
            onClick={onClick}
            color="text"
            hoverStyle={{ color: "common.ui1" }}
            typographyProps={{ ...spreadProps("headlineTypographyProps") }}
        >
            {title}
        </Link>
    );
};

export default withTheme(DrawerLink);
